import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AppPageRoutingModule } from './app-routing.module';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ngRxEffects } from 'src/app/services/ngrx/effects/ngrx.effects';
import {
	ngrxFeatureKey,
	ngrxReducer,
} from 'src/app/services/ngrx/reducer/ngrx.reducer';
import { MainHeaderComponentModule } from '../../component/main-header/main-header.component.module';
import { ProfileService } from '../services/profile.service';
import { AppPage } from './app.page';
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		AppPageRoutingModule,
		ScrollingModule,
		MainHeaderComponentModule,
		StoreModule.forFeature(ngrxFeatureKey, ngrxReducer),
		EffectsModule.forFeature([ngRxEffects]),
	],
	declarations: [AppPage],
	providers: [ProfileService],
})
export class AppPageModule {}
